import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { ProblemHeadset } from 'src/models';
import { RootState } from 'src/store';
import { problemHeadsetsSelectors } from 'src/store/reducers/problemHeadsets';

export const useProblemHeadsetsState = (): RootState['problemHeadsets'] => {
  const state = useSelector<RootState, RootState['problemHeadsets']>(
    (state) => state.problemHeadsets,
  );

  useDebugValue(state);

  return state;
};

export const useProblemHeadsets = (): ProblemHeadset[] => {
  const state = useSelector<RootState, RootState['problemHeadsets']>(
    (state) => state.problemHeadsets,
  );

  const headsets = problemHeadsetsSelectors.selectAll(state);

  useDebugValue(headsets);

  return headsets;
};

export const useProblemHeadsetCompanies = (): {
  company: string;
  id: string;
}[] => {
  const state = useSelector<RootState, RootState['problemHeadsets']>(
    (state) => state.problemHeadsets,
  );

  const headsets = problemHeadsetsSelectors.selectAll(state);

  useDebugValue(headsets);
  const companies: { [key: string]: string } = {};
  headsets.forEach((h) => (companies[h.companyId] = h.companyName));

  return Object.keys(companies).map((key) => ({
    company: companies[key],
    id: key,
  }));
};
